import { DeviceChecker } from './deviceChecker';
const deviceChecker = new DeviceChecker();

/**
 * 画面幅に応じてテキストを繰り返す処理
 * - PCの場合、指定のテキストを10回繰り返す
 * - モバイルの場合は何もしない
 */
export default function () {
	$(window).on('load resize', deviceChecker._debounce(() => {
		if (deviceChecker._isPc()) {
			// PCの場合、指定テキストを10回繰り返す
			const $textRepeat = $('.js-text_repeat');
			if ($textRepeat.length) {
				const repeatedText = $textRepeat.text().repeat(10);
				$textRepeat.text(repeatedText);
			}
		} else {
			// モバイルの場合は処理なし
		}
	}, 200));
}
